import React from 'react';
import styles from './styles.module.scss';

function FooterComponent({ showFooter = true, showContacts = true }) {
  return (
    showFooter && (
      <footer id="main-footer" style={{ display: 'flex' }} className={`${styles.footer}`}>
        <div className="px-3">
          <div style={{ fontSize: '0.75rem' }} className="color-white">
            A SuperSim pertence e é operada pela SUPERSIM ANALISE DE DADOS E CORRESPONDENTE BANCARIO LTDA., 
            registrada sob o CNPJ/MF 33.030.944/0001-60, localizada na Av. Nove de Julho, 5143 - Conj 121 - Jardim Paulista - São Paulo - SP - 
            01.407-906. {showContacts && (<>Contato: Telefone: (11) 4003-9528 - aberta das 8h às 23h, de segunda à sábado. Aos domingos das 8h às 20h.</>)} Somos um correspondente 
            bancário da BMP SOCIEDADE DE CRÉDITO DIRETO S.A., inscrita no CNPJ/MF sob o nº 34.337.707/0001-00 e possuímos uma plataforma online 
            com produtos e serviços ofertados por instituições financeiras parceiras. Nosso prazo de pagamento varia de 3 a 12 meses, a taxa de juros praticada 
            no produto de crédito pessoal é de 12,5% a.m. (310.99% a.a.) até 19.9% a.m. (819% a.a.) e o custo efetivo total (CET) será a partir de 12.82% a.m. 
            (325.31% a.a.). A tarifa de cadastro (TAC) é de R$ 90 até R$ 150. Ao solicitar uma proposta, serão exibidos a taxa de juros utilizada, a tarifa, 
            o imposto (IOF) e o custo efetivo total (CET). Exemplo: um empréstimo de R$ 1000 em 12 meses com taxa de juros de 12.5% a.m. (310.99% a.a.) terá parcelas 
            de R$ 175.72 e CET de 12.9% a.m. (325.31% a.a.). * <a href="https://www.supersim.com.br/termos/condicoes/"><b>Veja termos e condições</b></a>
          </div>
        </div>
      </footer>
    )
  );
}

export default FooterComponent;
